
import React from 'react';
import Modal from 'react-modal';
import Button from '../Forms/Button';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '80vh',
        maxWidth: '80vw',
        padding: '6px',
        border: 'none',
        boxShadow: 'none',
        background: 'transparent',
        borderRadius: '10px',
        overflow: 'visible',
    }
};

interface CloseBillEventConfirmProps {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

function CloseBillEventConfirm({ isOpen, onCancel, onConfirm }: CloseBillEventConfirmProps) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onCancel}
            style={customStyles}
            ariaHideApp={false}
            contentLabel="Confirma cerrar factura pendiente"
        >
            <div className="card table" id="closeBillEventConfirm">
                <div className="cardTitle withClose">
                    <h4>Confirma cerrar factura pendiente</h4>
                    <i className="material-icons" onClick={onCancel}>cancel</i>
                </div>
                <div className="cardBody">
                    <p>
                        Cierra el recordatorio si estás seguro que no será necesario emitir la factura o bien fué realizado externamente.
                    </p>
                    <p>
                        Si solamente deseas quitar el recordatorio, puedes silenciar en lugar de cerrar el recordatorio
                    </p>
                    <div className="_confirmActions">
                        <Button secondary={true} size="small" handleClick={onCancel}>
                            <span>Cancelar</span>
                        </Button>
                        <Button primary={true} size="small" handleClick={onConfirm}>
                            <span>Confirmar</span>
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default CloseBillEventConfirm;
